// BusinessUnits.js
import React from 'react';
import { motion } from 'framer-motion';
import gastonPic from '../assets/fotos/FOTO_GASTON.jpg';
import karinaPic from '../assets/fotos/FOTO_KARINA.jpg';

import CardPerfil from './CardPerfil';

const Nosotros = () => {
    const unitsData = [
        { title: 'Karina Meza', description: 'Ingeniera Electromecanica', img: karinaPic },
        { title: 'Gaston Cacchiarelli', description: 'Ingeniero Electonico', img: gastonPic },
    ];

    return (
        <motion.section
            id="nosotros"
            className="py-20"
            style={{ backgroundColor: 'var(--background-color-typeA' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <div className="container mx-auto px-4 sm:px-6 lg:px-[10%] text-lg text-justify">
                <h3 className="text-3xl mb-2 text-center">Nosotros</h3>

                <p className="mb-2 ">
                    Somos una empresa especializada en dos pilares fundamentales de la ingeniería moderna, por un lado especializados en el desarrollo de ingeniería electromecánica, y por el otro  en el desarrollo e implementación de automatización industrial 4.0.
                </p>
                <p className="mb-2">
                    Nuestro propósito es ofrecer un asesoramiento integral y soluciones innovadoras que sean confiables, rentables y altamente eficientes. Nos enfocamos en garantizar la calidad y la satisfacción del cliente, respaldados por un equipo de expertos comprometidos con el éxito de cada proyecto.
                </p>

                <p className="mb-8">
                    En ENERBYTE, creemos que la ingeniería no solo resuelve problemas, sino que también crea oportunidades para un futuro más conectado, sostenible y productivo.</p>

              {/*  <div className="grid lg:px-[20%]  grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-8">
                    {unitsData.map((unit, index) => (
                        <CardPerfil
                            key={index}
                            name={unit.title}
                            description={unit.description}
                            image={unit.img}
                        >
                        </CardPerfil>
                    ))}
                </div> */}
            </div>



        </motion.section>



    );
};

export default Nosotros;